// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"8ed1420a","297":"d880c32c","643":"7f5a2822","787":"711141dc"}[chunkId] + ".chunk.js";
};